import {Button} from "./Button";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router";
import Bill from "../store/models/Bill";
import _ from "lodash";
import React, {useEffect, useState} from "react";
import User, {selectCurrentUser, selectCurrentUserId} from "../store/models/User";
import {pushTo} from "../store/history";
import {Link, NavLink} from "react-router-dom";
import {createSelector} from "reselect";
import {ModalTypes, ShowcaseURls, Urls, UserRoleIds as UserRoles} from "../constants";
import Project, {selectCurrentProject, selectCurrentProjectId} from "../store/models/Project";
import {DownChevronIcon} from "./Svg";
import UIState from "../store/UIState";
import {selectCurrentOrgId} from "../store/models/Organization";
import cx from "classnames";
import {DropdownMenu, DropdownMenuItem} from "./DropdownMenu";
import {OrgAndProjectDropdown} from "./OrgAndProjectDropdowns";
import {ChatbotDropdown} from "./ChatbotDropdown";
import Ai, { selectAllRagChatbots } from "../store/models/Ai";

export const HeaderLink = ({to, target, onClick, name, active, className}) => {
  return (
    <NavLink className={cx('NavbarLink', {'NavbarLink--active': active}, className)}
             activeClassName={'NavbarLink--active'}
             to={to}
             onClick={onClick}
             target={target}
             rel="noopener noreferrer"
             exact
    >
      {name}
      {active && <div className={'NavbarLink__border'}/>}
    </NavLink>
  );
}

const selector = createSelector(
  selectCurrentUser,
  selectCurrentUserId,
  selectCurrentOrgId,
  selectCurrentProjectId,
  selectCurrentProject,
  (state) => selectAllRagChatbots(state, selectCurrentProjectId(state)),
  (user, userId, currentOrgId, currentProjectId, currentProject, chatbots) => {
    return {
      user,
      userId,
      currentOrgId,
      currentProjectId,
      currentProject,
      chatbots: _.values(chatbots),
    }
  }
);

export const MiniDashboardNavbar = ({}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const {user, userId, currentOrgId, currentProjectId, currentProject, chatbots}
    = useSelector(state => selector(state));


  const pathName = location.pathname;
  const isChatbotPage = pathName.includes('/manager/chatbot/');
  const hasChatbots = chatbots && chatbots.length > 0;

  useEffect(() => {
    if (!_.isNil(currentProjectId) && _.isEmpty(currentProject)) {
      dispatch(Project.actions.fetchProject(currentProjectId));
    }
  }, [currentProjectId]);

  useEffect(() => {
    if (currentProjectId && userId) {
      dispatch(Ai.actions.fetchRagChatbots(currentProjectId));
    }
  }, [currentProjectId, userId]);

  const onLogout = () => {
    dispatch(User.actions.logout(true))
  }

  const onOpenSettings = () => {
    pushTo(Urls.SETTINGS_PROFILE)
  }

  return (
    <div className={cx(`Navbar`)}>

      <div className={cx(`Navbar__content`)}>
        <Link to={Urls.MINI_DASHBOARD_HOME}>
          <img src={"/images/edgecloud-logo.svg"}
               alt={'theta-video-api-logo'}
               className={'Navbar__logo'}
          />
        </Link>

        {currentOrgId && !_.isNil(userId) &&
          <>
            <OrgAndProjectDropdown />
            {hasChatbots && (
              <>
                <div className={'Navbar__separator'}>/</div>
                <ChatbotDropdown />
              </>
            )}
          </>
        }

        <div className={'Navbar__user-content'}>
          <HeaderLink to={Urls.MINI_DASHBOARD_HOME}
                      name={'Home'}
                      active={pathName === Urls.MINI_DASHBOARD_HOME}/>

          {
            _.isNil(userId) && <>
              <HeaderLink
                className={"login-btn"}
                to={`/login`}
                name={'Log in'}/>

              <div className={"vertical-divider"}/>

              <HeaderLink to={`/sign-up`}
                          className={"signup-btn"}
                          name={'Sign up'}/>
            </>
          }

          {
            !_.isNil(userId) &&
            <DropdownMenu label={"Me"} className={"NavbarLink"}>
              <DropdownMenuItem label={"Account"}
                                className={"NavbarLink NavbarLink--account"}
                                onClick={onOpenSettings}/>

              <DropdownMenuItem label={"Logout"}
                                className={"NavbarLink NavbarLink--logout"}
                                onClick={onLogout}/>
            </DropdownMenu>
          }

        </div>
      </div>
    </div>
  )
}